declare global {
  interface Window {
    __POWERED_BY_WUJIE__?: boolean
  }
}

export const isWuJie = Boolean(window.__POWERED_BY_WUJIE__)
